import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "@/lib/LangContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="relative pt-24 lg:pt-32 pb-10 border-t border-white/10 bg-[#030303] overflow-hidden" data-testid="footer">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 pb-24 lg:pb-32 border-b border-white/10">
          <div className="lg:col-span-8">
            <div className="text-[11px] uppercase tracking-[0.28em] text-red-400 font-mono-ef">
              — {t.footer.cta_overline}
            </div>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="mt-6 font-display font-black text-5xl sm:text-6xl lg:text-8xl leading-[0.9] tracking-[-0.035em] max-w-4xl"
            >
              {t.footer.cta_title}
            </motion.h2>
            <p className="mt-6 text-white/55 text-lg max-w-lg">{t.footer.cta_sub}</p>
          </div>
          <div className="lg:col-span-4 lg:pt-16 flex items-end">
            <Link to="/start" data-testid="footer-cta" className="btn-pill btn-primary text-base">
              {t.footer.cta_btn}
              <svg className="ml-2" width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M5 12h14M13 5l7 7-7 7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Link>
          </div>
        </div>

        {/* Giant wordmark */}
        <div className="py-16 lg:py-20 overflow-hidden">
          <div className="font-display font-black text-[24vw] leading-[0.8] tracking-[-0.06em] text-stroke-emerald select-none">
            EMERGENT
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6 pt-8 border-t border-white/10 text-sm text-white/50">
          <div>{t.footer.legal.replace("2025", String(new Date().getFullYear()))}</div>
          <div className="flex items-center gap-6">
            {t.footer.links.map((l) => (
              <a key={l} href="#" className="hover:text-white transition-colors">
                {l}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
